/* Belove Beauty PDP — Interactive JS */

(function () {
  'use strict';

  /* ── Gallery ── */
  function initGallery() {
    const galleries = document.querySelectorAll('[data-bb-gallery]');
    galleries.forEach(function (gallery) {
      const imgs = gallery.querySelectorAll('[data-bb-gallery-img]');
      const thumbs = gallery.querySelectorAll('[data-bb-gallery-thumb]');
      const dots = gallery.querySelectorAll('[data-bb-gallery-dot]');

      function go(i) {
        var idx = Math.max(0, Math.min(i, imgs.length - 1));
        imgs.forEach(function (img, j) { img.classList.toggle('hidden', j !== idx); });
        thumbs.forEach(function (t, j) { t.classList.toggle('active', j === idx); });
        dots.forEach(function (d, j) { d.classList.toggle('active', j === idx); });
      }

      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });

      gallery._bbGo = go;
    });
  }

  /* ── Variant / Shade Selector ── */
  function initVariants() {
    const form = document.getElementById('bb-product-form');
    if (!form) return;

    const variantInput = form.querySelector('[name="id"]');
    const swatches = document.querySelectorAll('[data-bb-swatch]');
    const titleEl = document.getElementById('bb-shade-name');
    const titleEl2 = document.getElementById('bb-shade-name-2');
    const tagEl = document.getElementById('bb-shade-tag');
    const priceEl = document.getElementById('bb-price-main');
    const comparePriceEl = document.getElementById('bb-price-compare');
    const stickySwatchEl = document.querySelector('.bb-sticky-bar__swatch');
    const stickyNameEl = document.querySelector('.bb-sticky-bar__name');
    const gallery = document.querySelector('[data-bb-gallery]');

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        const variantId  = swatch.dataset.variantId;
        const shadeName  = swatch.dataset.shadeName;
        const shadeTag   = swatch.dataset.shadeTag;
        const price      = swatch.dataset.price;
        const rawPrice   = swatch.dataset.rawPrice;
        const comparePrice = swatch.dataset.comparePrice;
        const shadeColor = swatch.dataset.shadeColor;
        const shadeLink  = swatch.dataset.shadeLink;
        const imgIndex   = parseInt(swatch.dataset.imgIndex || '0', 10);

        // Mark active immediately (visual feedback before navigate)
        swatches.forEach(function (s) { s.classList.remove('active'); });
        swatch.classList.add('active');

        // If each shade is its own product, navigate to it
        if (shadeLink && shadeLink.trim() !== '') {
          window.location.href = shadeLink;
          return;
        }

        // Otherwise do in-page variant switch (single product with colour variants)
        if (variantInput) variantInput.value = variantId;
        if (titleEl)  titleEl.textContent  = shadeName;
        if (titleEl2) titleEl2.textContent = shadeName;
        if (tagEl)    tagEl.textContent    = shadeTag;
        if (priceEl) {
          priceEl.textContent = price;
          if (rawPrice) priceEl.dataset.rawPrice = rawPrice;
        }
        if (comparePriceEl && comparePrice) {
          comparePriceEl.textContent = comparePrice;
          comparePriceEl.style.display = '';
        } else if (comparePriceEl) {
          comparePriceEl.style.display = 'none';
        }
        if (stickySwatchEl && shadeColor) stickySwatchEl.style.background = shadeColor;
        if (stickyNameEl) stickyNameEl.textContent = shadeName + ' · Soft Lip Blur';

        if (gallery && typeof gallery._bbGo === 'function') gallery._bbGo(imgIndex);

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.history.replaceState({}, '', url.toString());

        updateATCPrice();
      });
    });
  }

  /* ── Quantity ── */
  function initQty() {
    const qtyInputs = document.querySelectorAll('[data-bb-qty]');
    qtyInputs.forEach(function (wrap) {
      const display = wrap.querySelector('[data-bb-qty-val]');
      const dec = wrap.querySelector('[data-bb-qty-dec]');
      const inc = wrap.querySelector('[data-bb-qty-inc]');
      const hiddenInput = document.getElementById('bb-qty-input');
      let qty = 1;

      function update() {
        display.textContent = qty;
        if (hiddenInput) hiddenInput.value = qty;
        updateATCPrice();
      }

      dec.addEventListener('click', function () { if (qty > 1) { qty--; update(); } });
      inc.addEventListener('click', function () { qty++; update(); });
    });
  }

  function updateATCPrice() {
    const atcBtn = document.getElementById('bb-atc-btn');
    const priceEl = document.getElementById('bb-price-main');
    const qtyInput = document.getElementById('bb-qty-input');
    if (!atcBtn || !priceEl) return;

    const rawPrice = priceEl.dataset.rawPrice;
    if (!rawPrice) return;
    const qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    const total = parseInt(rawPrice, 10) * qty;
    atcBtn.textContent = 'Add to Cart · ₹' + total.toLocaleString('en-IN');
  }

  /* ── Coupon Copy ── */
  function initCoupon() {
    const btn = document.getElementById('bb-coupon-btn');
    if (!btn) return;
    const code = btn.dataset.code || 'BELOVE10';
    const label = btn.querySelector('[data-bb-copy-label]');

    btn.addEventListener('click', function () {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(code).then(function () { flash(); });
      } else {
        flash();
      }
    });

    function flash() {
      if (label) label.textContent = '✓ Copied!';
      setTimeout(function () { if (label) label.textContent = 'Tap to copy'; }, 1800);
    }
  }

  /* ── FAQ Accordion ── */
  function initFAQ() {
    const items = document.querySelectorAll('.bb-faq-item');
    items.forEach(function (item) {
      const btn = item.querySelector('.bb-faq-item__btn');
      btn.addEventListener('click', function () {
        const isOpen = item.classList.contains('open');
        items.forEach(function (i) { i.classList.remove('open'); });
        if (!isOpen) item.classList.add('open');
      });
    });
  }

  /* ── Review Filters ── */
  function initReviewFilters() {
    const btns = document.querySelectorAll('[data-bb-filter]');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        btns.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
      });
    });
  }

  /* ── Activate the swatch matching the current page URL ── */
  function initActiveShade() {
    var swatches = document.querySelectorAll('[data-bb-swatch]');
    if (!swatches.length) return;
    var currentPath = window.location.pathname.toLowerCase().replace(/\/$/, '');
    var best = null;
    swatches.forEach(function (swatch) {
      var slug = (swatch.dataset.shadeName || '').toLowerCase().replace(/\s+/g, '-');
      if (slug && currentPath.indexOf(slug) !== -1) best = swatch;
    });
    if (!best) return;
    swatches.forEach(function (s) { s.classList.remove('active'); });
    best.classList.add('active');
    var name  = best.dataset.shadeName  || '';
    var tag   = best.dataset.shadeTag   || '';
    var color = best.dataset.shadeColor || '';
    var nameEl      = document.getElementById('bb-shade-name');
    var nameEl2     = document.getElementById('bb-shade-name-2');
    var tagEl       = document.getElementById('bb-shade-tag');
    var stickyColor = document.querySelector('.bb-sticky-bar__swatch');
    var stickyName  = document.querySelector('.bb-sticky-bar__name');
    if (nameEl)       nameEl.textContent       = name;
    if (nameEl2)      nameEl2.textContent      = name;
    if (tagEl)        tagEl.textContent        = tag;
    if (stickyColor && color) stickyColor.style.background = color;
    if (stickyName)   stickyName.textContent   = name + ' · Soft Lip Blur';
  }

  /* ── Resolve swatch URLs + activate current shade via Shopify search API ── */
  function resolveSwatchURLs() {
    var swatches = document.querySelectorAll('[data-bb-swatch]');
    if (!swatches.length) return;
    var currentPath = window.location.pathname.replace(/\/$/, '');
    fetch('/search/suggest.json?q=soft+lip+blur&resources[type]=product&resources[limit]=20')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        swatches.forEach(function (swatch) {
          var shadeName = (swatch.dataset.shadeName || '').toLowerCase().trim();
          if (!shadeName) return;
          var match = null;
          for (var i = 0; i < products.length; i++) {
            if (products[i].title && products[i].title.toLowerCase().indexOf(shadeName) !== -1) {
              match = products[i];
              break;
            }
          }
          if (match && match.url) {
            swatch.dataset.shadeLink = match.url;
          }
        });

        // Now activate the swatch whose link matches the current page URL
        var activeSwatch = null;
        swatches.forEach(function (swatch) {
          var link = (swatch.dataset.shadeLink || '').replace(/\/$/, '');
          if (link && link === currentPath) {
            activeSwatch = swatch;
          }
        });
        if (activeSwatch) {
          swatches.forEach(function (s) { s.classList.remove('active'); });
          activeSwatch.classList.add('active');
          var name = activeSwatch.dataset.shadeName || '';
          var tag  = activeSwatch.dataset.shadeTag  || '';
          var color = activeSwatch.dataset.shadeColor || '';
          var nameEl  = document.getElementById('bb-shade-name');
          var nameEl2 = document.getElementById('bb-shade-name-2');
          var tagEl   = document.getElementById('bb-shade-tag');
          var stickyColor = document.querySelector('.bb-sticky-bar__swatch');
          var stickyName  = document.querySelector('.bb-sticky-bar__name');
          if (nameEl)  nameEl.textContent  = name;
          if (nameEl2) nameEl2.textContent = name;
          if (tagEl)   tagEl.textContent   = tag;
          if (stickyColor && color) stickyColor.style.background = color;
          if (stickyName) stickyName.textContent = name + ' · Soft Lip Blur';
        }
      })
      .catch(function () {});
  }

  /* ── Init ── */
  document.addEventListener('DOMContentLoaded', function () {
    initGallery();
    initVariants();
    initQty();
    initCoupon();
    initFAQ();
    initReviewFilters();
    initActiveShade();
    resolveSwatchURLs();
  });
})();
